export const tempConfig = {
  bannerConfig: {},
  willStartConfig: {
    visible: 0
  },
  wonderfulVideoConfig: {
    visible: 0
  },
  groupAConfig: {
    visible: 0
  },
  groupBConfig: {
    visible: 0
  },
  bottomConfig: {
    visible: 0
  },
  site_menu: []
};

export const category = {
  list: []
};
